import { HttpClient } from '@angular/common/http';
import { Injectable, InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { SearchConfig } from '@spartacus/core';
import {
  Converter,
  EntitiesModel,
  OccEndpointsService,
  ConverterService
} from '@spartacus/core';
import { AccessSubject, AccessSubjectList } from './uig-access-subject.model';

export const UIG_ACCESS_SUBJECT_NORMALIZER = new InjectionToken<Converter<any, AccessSubject>>(
  'AccessSubjectNormalizer'
);

export const UIG_ACCESS_SUBJECTS_NORMALIZER = new InjectionToken<
  Converter<any, EntitiesModel<AccessSubject>>
>('AccessSubjectsListNormalizer');

@Injectable()
export class UigAccessSubjectAdapter {
  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService,
    protected converter: ConverterService
  ) { }

  getUigAccessSubject(params?: SearchConfig): Observable<AccessSubjectList> {
    return this.http.get<AccessSubjectList>(
      this.occEndpoints.buildUrl('uigAccessSubject', {queryParams: params})
    );
  }
}
